import type { FlowThemeCardMotion } from '../../cardMotion';

/** The card settles softly into place, like a stone set into sand. */
export const zenCardMotion = (): FlowThemeCardMotion => ({
  variants: {
    enter: () => ({ opacity: 0, y: -18, scale: 1.02 }),
    center: { opacity: 1, y: 0, scale: 1 },
    exit: () => ({ opacity: 0, y: 10, scale: 0.98 }),
  },
  transition: { duration: 0.9, ease: [0.25, 1, 0.5, 1] },
});
